import { lazy, Suspense, useEffect, useRef, useState } from "react";

const ContactForm = lazy(() => import("./ContactForm"));

// Carga el formulario (y libphonenumber) recién cuando se acerca al viewport.
export default function LazyContact() {
  const ref = useRef(null);
  const [show, setShow] = useState(() => window.location.hash === "#contact");
  useEffect(() => {
    if (show) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setShow(true), { rootMargin: "800px" });
    io.observe(ref.current);
    const onHash = () => window.location.hash === "#contact" && setShow(true);
    window.addEventListener("hashchange", onHash);
    return () => { io.disconnect(); window.removeEventListener("hashchange", onHash); };
  }, [show]);
  const placeholder = <section id="contact" ref={ref} className="bg-white py-24" style={{ minHeight: 900 }} />;
  if (!show) return placeholder;
  return <Suspense fallback={placeholder}><ContactForm /><ScrollFix /></Suspense>;
}

// Re-scroll a #contact una vez montado el form y asentado el layout.
function ScrollFix() {
  useEffect(() => {
    if (window.location.hash !== "#contact") return;
    const go = () => document.getElementById("contact")?.scrollIntoView({ block: "start" });
    const timers = [setTimeout(go, 50), setTimeout(go, 600), setTimeout(go, 1400)];
    return () => timers.forEach(clearTimeout);
  }, []);
  return null;
}
